import "@orestbida/iframemanager/src/iframemanager";

// Initialize and export the iframe manager
const initIframeManager = () => {
	const im = window.iframemanager();

	// Make iframe manager globally accessible for cookie consent integration
	window.iframemanager = im;

	im.run({
		currLang: document.documentElement.lang?.split("-")[0] || "de",

		// This is the key integration point with CookieConsent
		onChange: ({ changedServices, eventSource }) => {
			if (eventSource.type === "click") {
				const servicesToAccept = [
					...(window.cookieConsent?.getUserPreferences()
						?.acceptedServices?.["external"] || []),
					...changedServices,
				];

				// Accept services in cookie consent when user clicks load button
				if (window.cookieConsent && servicesToAccept.length > 0) {
					window.cookieConsent.acceptService(
						servicesToAccept,
						"external",
					);
				}
			}
		},

		services: {
			// YouTube videos
			youtube: {
				embedUrl: "https://www.youtube-nocookie.com/embed/{data-id}",
				iframe: {
					allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share",
					allowFullscreen: true,
					loading: "lazy",
				},
				languages: {
					de: {
						notice: "Dieses Video wird von einem Drittanbieter (YouTube) gehostet. Durch das Laden des Videos werden Daten mit YouTube geteilt.",
						loadBtn: "Video laden",
						loadAllBtn: "Immer laden",
					},
					en: {
						notice: "This video is hosted by a third party (YouTube). By loading the video, data will be shared with YouTube.",
						loadBtn: "Load video",
						loadAllBtn: "Always load",
					},
				},
			},

			// Vimeo videos
			vimeo: {
				embedUrl: "https://player.vimeo.com/video/{data-id}",
				iframe: {
					allow: "autoplay; fullscreen; picture-in-picture",
					allowFullscreen: true,
					loading: "lazy",
				},
				languages: {
					de: {
						notice: "Dieses Video wird von einem Drittanbieter (Vimeo) gehostet. Durch das Laden des Videos werden Daten mit Vimeo geteilt.",
						loadBtn: "Video laden",
						loadAllBtn: "Immer laden",
					},
					en: {
						notice: "This video is hosted by a third party (Vimeo). By loading the video, data will be shared with Vimeo.",
						loadBtn: "Load video",
						loadAllBtn: "Always load",
					},
				},
			},

			// Google Maps
			googleMaps: {
				embedUrl: "https://www.google.com/maps/embed?pb={data-id}",
				iframe: {
					loading: "lazy",
				},
				languages: {
					de: {
						notice: "Diese Karte wird von Google Maps bereitgestellt. Beim Laden werden Daten mit Google geteilt.",
						loadBtn: "Karte laden",
						loadAllBtn: "Immer laden",
					},
					en: {
						notice: "This map is provided by Google Maps. By loading it, data will be shared with Google.",
						loadBtn: "Load map",
						loadAllBtn: "Always load",
					},
				},
			},

			// Facebook content (posts, videos, etc.)
			facebook: {
				embedUrl:
					"https://www.facebook.com/plugins/post.php?href={data-id}",
				iframe: {
					loading: "lazy",
					scrolling: "no",
					style: "border:none;overflow:hidden",
				},
				languages: {
					de: {
						notice: "Dieser Inhalt wird von Facebook bereitgestellt. Beim Laden werden Daten mit Meta (Facebook) geteilt.",
						loadBtn: "Facebook-Inhalt laden",
						loadAllBtn: "Immer laden",
					},
					en: {
						notice: "This content is provided by Facebook. By loading it, data will be shared with Meta (Facebook).",
						loadBtn: "Load Facebook content",
						loadAllBtn: "Always load",
					},
				},
			},

			// Generic iframe handler for all other iframe types
			generic: {
				embedUrl: "{data-id}",
				iframe: {
					loading: "lazy",
				},
				languages: {
					de: {
						notice: "Dieser Inhalt wird von einem Drittanbieter gehostet. Beim Laden werden Daten mit dem Anbieter geteilt.",
						loadBtn: "Inhalt laden",
						loadAllBtn: "Immer laden",
					},
					en: {
						notice: "This content is hosted by a third party. By loading it, data will be shared with the provider.",
						loadBtn: "Load content",
						loadAllBtn: "Always load",
					},
				},
			},
		},
	});

	// Check for already accepted services on initialization
	if (window.cookieConsent) {
		const acceptedServices =
			window.cookieConsent.getUserPreferences()?.acceptedServices
				?.external || [];
		acceptedServices.forEach((service) => {
			im.acceptService(service);
		});
	}

	return im;
};

export default initIframeManager;
